export default {
  // General
  title: 'Projects',
  subtitle: 'Manage and track your projects',
  new: 'New Project',
  edit: 'Edit Project',
  view: 'View Project',
  delete: 'Delete Project',
  noProjects: 'No projects',
  noProjectsDescription: 'Get started by creating a new project.',
  searchPlaceholder: 'Search projects...',
  resultsCount: 'Results',
  
  // Fields
  fields: {
    name: 'Project Name',
    description: 'Description',
    status: 'Status',
    priority: 'Priority',
    startDate: 'Start Date',
    endDate: 'End Date',
    customer: 'Customer',
    assignedUsers: 'Assigned Users',
    selectedUsers: 'Selected Users',
    progress: 'Progress',
    budget: 'Budget',
    actualCost: 'Actual Cost',
    tags: 'Tags',
    notes: 'Notes',
    documents: 'Documents',
    tasks: 'Tasks',
    createdAt: 'Created',
    updatedAt: 'Updated',
    createdBy: 'Created By'
  },
  
  // Sections
  sections: {
    basicInfo: 'Basic Information',
    timeProgress: 'Timing & Progress',
    teamClient: 'Team & Client',
    financeTags: 'Finance & Tags',
    tasks: 'Related Tasks'
  },
  
  // Forms
  form: {
    basicInfo: 'Basic Information',
    timing: 'Timing & Budget',
    teamAndClient: 'Client & Team',
    tagsAndNotes: 'Tags & Notes'
  },
  
  // Placeholders
  placeholders: {
    name: 'Enter project name',
    description: 'Enter project description',
    customer: 'Select customer...',
    assignedUsers: 'Select users...',
    budget: 'Enter budget',
    tags: 'New tag...',
    notes: 'Additional notes...',
    documents: 'Attach documents related to the project'
  },
  
  // Status
  status: {
    planning: 'Planning',
    active: 'Active',
    completed: 'Completed',
    paused: 'Paused',
    cancelled: 'Cancelled'
  },
  
  // Priority
  priority: {
    low: 'Low',
    medium: 'Medium',
    high: 'High',
    urgent: 'Urgent'
  },
  
  // Statistics
  stats: {
    total: 'Total Projects',
    active: 'Active',
    completed: 'Completed',
    overdue: 'Overdue',
    averageProgress: 'Average Progress'
  },
  
  // Validation messages
  validation: {
    nameRequired: 'Project name is required',
    descriptionRequired: 'Description is required',
    dateRange: 'End date cannot be earlier than start date',
    budgetPositive: 'Budget must be a positive number'
  },
  
  // Actions
  actions: {
    create: 'Create Project',
    update: 'Update Project',
    delete: 'Delete Project',
    addTask: 'Add Task',
    removeTask: 'Remove Task',
    calculateProgress: 'Calculate Progress',
    manageTasks: 'Manage Tasks'
  },
  
  // Messages
  messages: {
    created: 'Project created successfully',
    createSuccess: 'Project created successfully',
    updated: 'Project updated successfully',
    updateSuccess: 'Project updated successfully',
    deleted: 'Project deleted successfully',
    statusUpdated: 'Status updated successfully',
    priorityUpdated: 'Priority updated successfully',
    progressUpdated: 'Progress updated successfully',
    taskAdded: 'Task added to project',
    taskRemoved: 'Task removed from project',
    noTasks: 'No related tasks',
    createError: 'Error creating project',
    updateError: 'Error updating project',
    deleteError: 'Error deleting project',
    statusUpdateError: 'Error updating status',
    priorityUpdateError: 'Error updating priority',
    progressUpdateError: 'Error updating progress'
  },
  
  // Confirmation messages
  confirmDelete: 'Are you sure you want to delete this project?',
  confirmDeleteMessage: 'This action cannot be undone. All project data will be lost.',
  
  // Filters
  filters: {
    all: 'All Projects',
    my: 'My Projects',
    active: 'Active Projects',
    completed: 'Completed Projects',
    overdue: 'Overdue Projects'
  },
  
  // Timing
  overdue: 'Overdue',
  dueSoon: 'Due Soon',
  dueIn: 'Due in {{days}} days',
  completedOn: 'Completed: {{date}}',
  
  // Project details
  details: {
    overview: 'Overview',
    tasks: 'Tasks',
    timeline: 'Timeline',
    budget: 'Budget',
    team: 'Team',
    documents: 'Documents',
    notes: 'Notes'
  },
  
  // Progress
  progress: {
    notStarted: 'Not Started',
    inProgress: 'In Progress',
    completed: 'Completed',
    percentage: '{{progress}}% complete'
  }
}; 